// mds-dojo — dijit/form/ComboButton (lite). Keeps its srcNode as domNode so its
// nested <span> label + Menu dropdown stay in place; tagged .dijitComboButton.

import _WidgetBase from '../_WidgetBase';
import { mdsWidget } from '../../dojo/_base/declare';

// This freestyle leaf overrides buildRendering as a native method. declare() types its
// props hooks as function-valued PROPERTIES, and TS forbids overriding a property with a
// method (TS2425 — and mapped types can't re-present a property as a method). Nothing
// extends ComboButton, so relax its base to a permissive ctor; runtime is unchanged.
const _WidgetBaseN = _WidgetBase as unknown as new (...a: any[]) => any;

class ComboButton extends _WidgetBaseN {
  dropDown: any = null;

  buildRendering(): void {
    super.buildRendering();
    this.domNode.classList.add('dijitComboButton');
  }

  _setDropDownAttr(v: any): void { this.dropDown = v; this._set('dropDown', v); }
}
ComboButton.prototype.declaredClass = 'dijit.form.ComboButton';
export default mdsWidget(ComboButton);
